const Permission = {
  Invoices: "Permission.Invoices",
  InvoicesAdmin: "Permission.InvoicesAdmin",
  InvoiceDescription: "Permission.InvoiceDescription",
  InvoiceAdminDescription: "Permission.InvoiceAdminDescription",
  IncomingInvoices: "Permission.IncomingInvoices",
  IncomingInvoicesOverview: "Permission.IncomingInvoicesOverview",
  IncomingInvoicesSignee: "Permission.IncomingInvoicesSignee",
  IncomingInvoicesAdmin: "Permission.IncomingInvoicesAdmin",
  PaymentFileSignee: "Permission.PaymentFileSignee",
  IncomingInvoicesDescription: "Permission.IncomingInvoicesDescription",
  IncomingInvoicesOverviewDescription: "Permission.IncomingInvoicesOverviewDescription",
  IncomingInvoicesSigneeDescription: "Permission.IncomingInvoicesSigneeDescription",
  IncomingInvoicesAdminDescription: "Permission.IncomingInvoicesAdminDescription",
  PaymentFileSigneeDescription: "Permission.PaymentFileSigneeDescription",
  Receipts: "Permission.Receipts",
  ReceiptsAdmin: "Permission.ReceiptsAdmin",
  ReceiptsDescription: "Permission.ReceiptsDescription",
  ReceiptsAdminDescription: "Permission.ReceiptsAdminDescription",
  Reports: "Permission.Reports",
  MissingDocumentAdmin: "Permission.MissingDocumentAdmin",
  Documents: "Permission.Documents",
  Agreement: "Permission.Agreement",
  CashReconciliation: "Permission.CashReconciliation",
  Auditor: "Permission.Auditor",
  Revisor: "Permission.Revisor",
  SalaryAdmin: "Permission.SalaryAdmin",
  PaymentSignee: "Permission.PaymentSignee",
  StoppedPaymentAdmin: "Permission.StoppedPaymentAdmin",
  Admin: "Permission.Admin",
  Contact: "Permission.Contact",
  ReportsDescription: "Permission.ReportsDescription",
  UploadGenericDocuments: "Permission.UploadGenericDocuments",
  UploadGenericDocumentsDescription: "Permission.UploadGenericDocumentsDescription",
  MissingDocumentAdminDescription: "Permission.MissingDocumentAdminDescription",
  DocumentsDescription: "Permission.DocumentsDescription",
  AgreementDescription: "Permission.AgreementDescription",
  CashReconciliationDescription: "Permission.CashReconciliationDescription",
  AuditorDescription: "Permission.AuditorDescription",
  SalaryAdminDescription: "Permission.SalaryAdminDescription",
  PaymentSigneeDescription: "Permission.PaymentSigneeDescription",
  StoppedPaymentAdminDescription: "Permission.StoppedPaymentAdminDescription",
  AdminDescription: "Permission.AdminDescription",
  ContactDescription: "Permission.ContactDescription",
  RevisorDescription: "Permission.RevisorDescription",
  Employee: "Permission.Employee",
  SpeedDialSalaryAdmin: "Permission.SpeedDialSalaryAdmin",
  CEO: "Permission.CEO",
  Advisor: "Permission.Advisor",
  AdvisorDescription: "Permission.AdvisorDescription",
  DeviationAdmin: "Permission.DeviationAdmin",
  DeviationAdminDescription: "Permission.DeviationAdminDescription",
  Board: "Permission.Board",
  BoardDescription: "Permission.BoardDescription",
  }
export default Permission;